import { TRACE_TOOLS_HOST } from '@/constant/common'

const traceTools = {
  getControlAgriGoods: {
    url: '/controlAgriGoods/find',
    method: 'get'
  },
  getAreaCode: { // 获取地区
    url: '/getAreaCode',
    method: 'get'
  },
  // 病虫害相关
  controlAgriDiseasesFindList: {
    url: '/controlAgriDiseases/findList',
    method: 'get'
  },
  controlAgriDiseasesFindById: {
    url: '/controlAgriDiseases/findById',
    method: 'get'
  },
  controlAgriDiseasesFindByName: {
    url: '/controlAgriDiseases/findByName',
    method: 'get'
  },
  controlAgriDiseasesFindDetail: {
    url: '/controlAgriDiseases/findDetail',
    method: 'get'
  },
  controlAgriDiseasesFindBreeding: {
    url: '/controlAgriDiseases/findBreeding',
    method: 'get'
  },
  // 禁用农药
  inputBannedPesticide: {
    url: '/inputBannedPesticide/find',
    method: 'get'
  },
  // 限用农药
  inputLimitPesticide: {
    url: '/inputLimitPesticide/find',
    method: 'get'
  },
  // 跟踪物流
  getTraceExpress: {
    url: '/getTraceExpress',
    method: 'get'
  }
}

for (const key in traceTools) {
  traceTools[key].url = TRACE_TOOLS_HOST + traceTools[key].url
}

export default traceTools
